export { default } from './text-block.view';
